module.exports = __webpack_public_path__ + "img/logo2.67f1bb17.png";